import React from 'react';
import { Link } from 'react-router-dom';
import './stem.css';
import { FaArrowLeft, FaCogs, FaNetworkWired, FaIndustry, FaCode, FaGraduationCap, FaMicrochip } from 'react-icons/fa';

const EngineeringPage = () => {
  const programCategories = [
    {
      title: "Engineering Entrance Preparation",
      description: "Expert coaching for engineering competitive exams",
      courses: [
        { name: "GATE Preparation", description: "Comprehensive coaching for all engineering branches of GATE", icon: <FaGraduationCap /> },
        { name: "ESE (Engineering Services Exam)", description: "Preparation for prestigious engineering positions in government", icon: <FaGraduationCap /> },
        { name: "PSU Recruitment Training", description: "Specialized coaching for Public Sector Undertaking recruitment tests", icon: <FaIndustry /> },
        { name: "Technical Interview Preparation", description: "Mock interviews and problem-solving sessions for tech interviews", icon: <FaGraduationCap /> }
      ]
    },
    {
      title: "Core Engineering Skills",
      description: "Advanced training in fundamental engineering disciplines",
      courses: [
        { name: "Embedded Systems Engineering", description: "Microcontroller programming, IoT design, and embedded application development", icon: <FaMicrochip /> },
        { name: "Electrical & Electronics Engineering", description: "Circuit design, power systems, and electronic systems integration", icon: <FaCogs /> },
        { name: "Mechanical Engineering", description: "CAD/CAM, thermal systems, fluid mechanics, and mechanical design", icon: <FaIndustry /> },
        { name: "Civil & Structural Engineering", description: "Structural analysis, construction management, and infrastructure planning", icon: <FaIndustry /> }
      ]
    },
    {
      title: "Industry 4.0 Technologies",
      description: "Skills for the next industrial revolution",
      courses: [
        { name: "Industrial Automation", description: "PLC programming, SCADA systems, and industrial IoT applications", icon: <FaIndustry /> },
        { name: "Engineering Software Development", description: "Programming for simulation, modeling, and engineering applications", icon: <FaCode /> },
        { name: "Robotics & Control Systems", description: "Robot kinematics, control theory, and automation implementation", icon: <FaCogs /> },
        { name: "Network Engineering", description: "Advanced networking protocols, security, and infrastructure design", icon: <FaNetworkWired /> }
      ]
    }
  ];

  return (
    <div className="program-page engineering-theme my-5 py-5">
      <div className="program-header">
        <Link to="/" className="text-start">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="program-title">
          <FaCogs className="program-header-icon" />
          <h1>Engineering Programs</h1>
        </div>
        <p className="program-subtitle">Problem-solving, design principles, and advanced engineering skills</p>
      </div>

      <div className="program-overview">
        <h2>Why Choose Our Engineering Coaching?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Industry Experts</h3>
            <p>Learn from experienced engineers with real-world project experience</p>
          </div>
          <div className="feature-card">
            <h3>Practical Workshops</h3>
            <p>Hands-on training with industry-standard tools and equipment</p>
          </div>
          <div className="feature-card">
            <h3>Design Thinking</h3>
            <p>Develop a problem-solving mindset through design challenges</p>
          </div>
          <div className="feature-card">
            <h3>Career Pathways</h3>
            <p>Guidance for both academic advancement and industry placement</p>
          </div>
        </div>
      </div>

      <div className="courses-section">
        {programCategories.map((category, index) => (
          <div className="course-category" key={index}>
            <h2>{category.title}</h2>
            <p className="category-description">{category.description}</p>
            
            <div className="courses-grid">
              {category.courses.map((course, courseIndex) => (
                <div className="course-card" key={courseIndex}>
                  <div className="course-icon">{course.icon}</div>
                  <h3>{course.name}</h3>
                  <p>{course.description}</p>
                  <button className="enroll-btn">Learn More</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="projects-showcase">
        <h2>Student Projects</h2>
        <p>Our engineering students work on real-world projects that solve actual problems</p>
        <div className="projects-grid">
          <div className="project-card">
            <h3>Smart Traffic Management System</h3>
            <p>IoT-based traffic monitoring and optimization using embedded systems</p>
          </div>
          <div className="project-card">
            <h3>Solar-Powered Water Purification</h3>
            <p>Sustainable engineering solution for clean water in remote areas</p>
          </div>
          <div className="project-card">
            <h3>Autonomous Delivery Robot</h3>
            <p>A small-scale robotic platform for last-mile delivery automation</p>
          </div>
        </div>
      </div>

      <div className="testimonials-section">
        <h2>Success Stories</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"The GATE preparation program was comprehensive and rigorous. I secured AIR 120 and got admission to IIT Bombay for M.Tech."</p>
            <p className="testimonial-author">- Rahul D., M.Tech Student, IIT Bombay</p>
          </div>
          <div className="testimonial-card">
            <p>"The embedded systems course helped me bridge the gap between my theoretical knowledge and practical industry requirements. Now I'm working as an IoT developer."</p>
            <p className="testimonial-author">- Sneha G., Embedded Systems Engineer</p>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2>Ready to Engineer Your Future?</h2>
        <p>Join our engineering programs and develop problem-solving skills for real-world challenges</p>
        <button className="primary-btn">Schedule a Free Consultation</button>
      </div>
    </div>
  );
};

export default EngineeringPage;